import React, { useState, useEffect, useRef } from "react";

export const AddressAutocomplete = ({ handleSelectedAddress }) => {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const debounceTimeout = useRef(null);
  const containerRef = useRef(null);

  const fetchSuggestions = async (input) => {
    if (input.length > 3) {
      // Nominatim search endpoint
      const endpoint = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&q=${encodeURIComponent(
        input
      )}&limit=5`;

      try {
        const response = await fetch(endpoint, {
          headers: {
            "Accept-Language": "en", // Optional: force English results
          },
        });
        const data = await response.json();
        
        setSuggestions(
          data.map((item) => ({
            display_name: item.display_name,
            lat: parseFloat(item.lat),
            lon: parseFloat(item.lon),
            address: item.address,
          }))
        );
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleInputChange = (e) => {
    const input = e.target.value;
    setQuery(input);

    if (input.trim() === "") {
      setSuggestions([]);
      if (handleSelectedAddress) {
        handleSelectedAddress(null);
      }
      return;
    }

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      fetchSuggestions(input);
    }, 500);
  };

  const handleSuggestionClick = (suggestion) => {
    setQuery(suggestion.display_name);
    setSuggestions([]);

    if (handleSelectedAddress) {
      handleSelectedAddress({
        address: {
          ...suggestion.address,
          display_name: suggestion.display_name,
          latitude: suggestion.lat,
          longitude: suggestion.lon,
        },
      });
    }
  };

  const handleClickOutside = (event) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target)
    ) {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{ position: "relative", maxWidth: "400px", margin: "auto" }}
    >
      <input
        type="text"
        value={query}
        onChange={handleInputChange}
        placeholder="Enter an address"
        style={{
          width: "100%",
          padding: "10px",
          fontSize: "16px",
          borderRadius: "5px",
          border: "1px solid #ccc",
        }}
      />
      {suggestions.length > 0 && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "5px",
            zIndex: 1000,
            listStyle: "none",
            margin: 0,
            padding: "10px 0",
          }}
        >
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              style={{
                padding: "10px",
                cursor: "pointer",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              {suggestion.display_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
